<!--

 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-07-17 09:35:43
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-08-02 16:21:19
 * @FilePath: \xm-ngs\src\main-page\gridCellCtlShow\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <!-- 虚拟滚动占位行：跳过渲染 -->
  <template v-if="record.__isVirtualSpacer"></template>
  <!-- 合并行 -->
  <span v-else-if="recordGroupFlag"></span>
  <template v-else>
    <template v-if="isCellCtl && column.showContent !== 'userDef'">
      <a-tag v-for="(tagItem, tagIndex) in preLabels" :key="'pre-'+tagIndex" v-bind="cellLabelTagBind(tagItem)">
        <span>{{tagItem.label}}</span>
      </a-tag>
      <!-- tag 模式 + sufLabel -->
      <div v-if="isTagMode && hasCellContent && showSufLabel" class="cell-text-suf-wrap">
        <a-tag class="cell-text-part" :color="getTagColor">
          <component :is="getColShowType" v-bind="cellComponentProps" @click="cellClick(column)" @openDetail="openDetail" @reloadData="reloadData" @dblclick="handleCellDoubleClick(record, column)" />
          <template v-if="column.appendIcon"><span :class="column.appendIcon"></span></template>
        </a-tag>
        <a-tag v-for="(tagItem, tagIndex) in sufLabels" :key="'suf-tag-'+tagIndex" class="cell-suf-label" v-bind="cellLabelTagBind(tagItem)"><span>{{tagItem.label}}</span></a-tag>
      </div>
      <!-- tag 模式 -->
      <a-tag v-else-if="isTagMode && hasCellContent" :color="getTagColor">
        <component :is="getColShowType" v-bind="cellComponentProps" @click="cellClick(column)" @openDetail="openDetail" @reloadData="reloadData" @dblclick="handleCellDoubleClick(record, column)" />
        <template v-if="column.appendIcon"><span :class="column.appendIcon"></span></template>
      </a-tag>
      <!-- 普通 + sufLabel -->
      <div v-else-if="showSufLabel" class="cell-text-suf-wrap">
        <component :is="getColShowType" v-bind="cellComponentProps" class="no-tag-cell cell-text-part" :class="column.showColType" @click="cellClick(column)" @openDetail="openDetail" @reloadData="reloadData" @dblclick="handleCellDoubleClick(record, column)" />
        <template v-if="column.appendIcon&&column.showColType!=='linkText'"><span :class="column.appendIcon"></span></template>
        <a-tag v-for="(tagItem, tagIndex) in sufLabels" :key="'suf-tag-'+tagIndex" class="cell-suf-label" v-bind="cellLabelTagBind(tagItem)"><span>{{tagItem.label}}</span></a-tag>
      </div>
      <!-- 普通模式 -->
      <template v-else>
        <component :is="getColShowType" v-bind="cellComponentProps" class="no-tag-cell" :class="column.showColType" @click="cellClick(column)" @openDetail="openDetail" @reloadData="reloadData" @dblclick="handleCellDoubleClick(record, column)" />
        <template v-if="column.appendIcon&&column.showColType!=='linkText'"><span :class="column.appendIcon"></span></template>
      </template>
    </template>
    <template v-else>
      <div  v-if="column.showContent==='userDef'" class="userDefDiv flex-div" :class="column.showColType" style="align-items: center;">
        <div   @click="cellClick(column)" style="padding-right: 4px;">{{column.cellShowContent}}</div>
        <template v-if="column.appendIcon">
          <span :class="column.appendIcon"></span>
        </template>
      </div>
      <div v-else-if="column.showContent==='gongShiDef'" class="userDefDiv gongShiDef">
        <formula-val-cell  :record="record" :column="column" :cellContent="record[column.dataIndex||column.propId]"/>
        <template v-if="column.appendIcon">
          <span :class="column.appendIcon"></span>
        </template>
      </div>
      <span class="w100b text-dian-dian" v-else @click="cellClick(column)"
            :class="['cell-content',resolvedShowColType!==false&&column.showColType]" :title="getCellShowValue">
        <a-tag v-if="column.showColType==='tag'" :color="getTagColor">
          {{ getCellShowValue}}
        </a-tag>
        <template v-if="column.appendIcon">
          <span :class="column.appendIcon"></span>
        </template>
      </span>
    </template>
  </template>
</template>

<script lang="ts" setup>
import {Tag as ATag} from 'ant-design-vue';
import allCtls from './cellCtls/allCtls';
import cellClickEditorCtls from '../gridCellEditor/cellClickEditor/allCtls'
import {deepClone} from 'xmgoing-utils';
import {executeEventItem} from "@/main-page/ctls/hooks/useComEvent";
import FormulaValCell from "@/main-page/gridCellCtlShow/coms/formulaValCell.vue";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {storeToRefs} from "pinia";
import {ViewModel} from "@/main-page/jsParseEngine/ViewModel";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import cellCtlMap from './data/cellCtlMap';
import {isFlowColumnEditable} from "@/main-page/gridCellEditor/hooks/useSimpleFlowAclHooks";
import {resolveCellSideLabels, cellLabelTagBind} from "@/main-page/gridCellCtlShow/cellLabelRules";
import XmInputEditor from "@/main-page/gridCellEditor/editorCtls/xmInputEditor/index.vue";
import {textInputShowType, useTextDirectOn} from "@/main-page/gridCellCtlShow/textDirectColumn";

// ---- 模块级共享 ViewModel 单例（避免每个单元格创建独立实例）----
let _sharedViewModel: any = null;
const getSharedViewModel = () => {
  if (!_sharedViewModel) {
    const pageModelsStore = usePageModelsStore();
    const dataSourceStore = useDataSourceStore();
    const {state} = storeToRefs(pageModelsStore);
    _sharedViewModel = new ViewModel({viewPage: {}, pageModelsStore, dataSourceStore, state});
  }
  return _sharedViewModel;
};

// ---- 缓存 store 引用，避免在 computed 中重复调用 ----
let _pageModelsState: any = null;
const getPageModelsState = () => {
  if (!_pageModelsState) {
    const pageModelsStore = usePageModelsStore();
    const {state} = storeToRefs(pageModelsStore);
    _pageModelsState = state;
  }
  return _pageModelsState;
};

defineOptions({
  components: {
    ...cellClickEditorCtls,
    ...allCtls,
    xmInputEditor: XmInputEditor,
  },
  name: 'gridCellCtlShow'
})

interface IProps {
  clickCellEditor:boolean;
  preRecord:any;
  editorCell:boolean;
  columnId:string,
  options:any;
  closeEditorFlag:string;
  record: any;
  gridKey:string;
  index:any;
  column: any;
}
const props = withDefaults(defineProps<IProps>(), {
  columnId:'',
  editorCell:false,
  clickCellEditor:false,
  closeEditorFlag:'',
  record: () => ({}),
  options: {},
  preRecord:{},
  gridKey:'',
  index:{},
  column:{},
})
const {column,record,editorCell,clickCellEditor,preRecord,options}=toRefs(props);

// 计算groupFlag：支持三种合并方式
const recordGroupFlag = computed(() => {
  const col = unref(column);
  const rec = unref(record);
  const prevRec = unref(preRecord);
  if (col?.groupCol && prevRec && rec) {
    return rec[col.groupCol] === prevRec[col.groupCol];
  }
  if (!col?.groupCol && col?.hasGroupRow && prevRec && rec) {
    const currentValue = rec[col.propId] || rec[col.dataIndex];
    const prevValue = prevRec[col.propId] || prevRec[col.dataIndex];
    return currentValue === prevValue;
  }
  return false;
});

/**
 * 轻量级 showColType 解析：替代 useVuexState
 * 仅在 column.showColTypeVuex 存在时才进行表达式求值，
 * 否则直接使用 column.showColType（覆盖 99% 场景）
 */
const resolvedShowColType = computed(() => {
  const col = unref(column);
  if (!col.showColTypeVuex) {
    return col.showColType;
  }
  try {
    const state = getPageModelsState();
    const vuexObj: any = {recordData: {}, state: unref(state), record: unref(record)};
    const fun = new Function("vuex", `return ${col.showColTypeVuex}`);
    const result = fun(vuexObj);
    return result !== false ? col.showColType : false;
  } catch (e) {
    return col.showColType;
  }
});

/**
 * 合并 getColShowType 和 isCellCtl 为一个 computed，减少 50% 计算开销
 */
const flowContainer = inject('flowContainer', null);
const subTableAclConfigs: any = inject('subTableAclConfigs', []);
const simpleFlowAclConfigs: any = inject('simpleFlowAclConfigs', null);
// 流程容器内白名单未放行的列一律按只读单元格渲染，不挂点击编辑器（渲染漏斗统一把关）
const flowCellEditable = computed(() =>
  isFlowColumnEditable({column, flowContainer, subTableAclConfigs, simpleFlowAclConfigs})
);
const textDirectOn = useTextDirectOn(column, record);
const colShowInfo = computed(() => {
  const col = unref(column);
  const ce = unref(clickCellEditor) && flowCellEditable.value;
  const ed = unref(editorCell) && flowCellEditable.value;
  if (unref(textDirectOn)) {
    const showType = textInputShowType(ed, ce);
    return {showType, isCellCtl: true};
  }
  const colType = (col.controlType || col.propType) || 'xmInput';
  let showType: string;
  if (cellCtlMap[colType] && cellCtlMap[colType].length > 0) {
    showType = `${cellCtlMap[colType]}${ce ? 'ClickEditor' : ''}`;
  } else if ((colType + '').indexOf("Editor") >= 0) {
    if (ed) {
      showType = `${colType}${ce ? 'ClickEditor' : ''}`;
    } else {
      showType = `${(colType + '').replaceAll("Editor", "")}Cell${ce ? 'ClickEditor' : ''}`;
    }
  } else {
    showType = `${colType}Cell${ce ? 'ClickEditor' : ''}`;
  }
  const isCtl = (colType + '').indexOf("Editor") >= 0 || ce || !!allCtls[showType];
  return {showType, isCellCtl: isCtl};
});
const getColShowType = computed(() => colShowInfo.value.showType);
const isCellCtl = computed(() => colShowInfo.value.isCellCtl);

const emits=defineEmits(['reloadData','handleCellDoubleClick','openDetail']);
const openDetail=function ({column,record}){
  emits('openDetail',{column,record})
}
const reloadData = () => {
  emits('reloadData',{});
}
const getCellShowValue=computed(()=>{
  const cellValue=props.record[props.column.dataIndex||props.column.propId];
  if(cellValue==null||cellValue===""){
    return '';
  }
  return cellValue;
})

/**
 * 单元格点击事件（使用共享 ViewModel 替代每单元格 useComEvent 实例）
 */
const cellClick = (column) => {
  if(column.controlType==="Switch"){
    return;
  }
  if(column.showColType==='linkText'&&column.linkUrl){
    window.location.href=column.linkUrl;
  }
  if(column.jsContent){
    const eventItem:any={jsContent: column.jsContent};
    eventItem.inParams=[
      {label:'当前行',value:'record'},
      {label:'当前列',value:'column'},
    ]
    const viewModel = getSharedViewModel();
    executeEventItem({eventItem, inParams: {record:deepClone(unref(record)),column:unref(column)}, viewModel});
  }
}
/**
 * 获取标签颜色
 */
const getTagColor=computed(()=>{
  const {tagColors} = unref(column);
  if(tagColors&&tagColors.length>0){
    const itemObj=tagColors.filter((itemDb)=>{return (itemDb.label+'')===(unref(record)[unref(column).dataIndex]+'')})[0];
    if(unref(itemObj)){
      return unref(itemObj)["colColor"];
    }else{
      return unref(column).tagDefColor||'red';
    }
  }
  return unref(column).tagDefColor||'red';
})

const preLabels = computed(() => resolveCellSideLabels(unref(column), unref(record), 'pre'));
const sufLabels = computed(() => resolveCellSideLabels(unref(column), unref(record), 'suf'));
const showSufLabel = computed(() => sufLabels.value.length > 0);

const cellContentValue = computed(() => {
  return props.record[props.columnId || props.column.dataIndex || props.column.propId];
});

const hasCellContent = computed(() => {
  const val = cellContentValue.value;
  return val || val === 0;
});

const isTagMode = computed(() => {
  return getColShowType.value !== 'xmDataSelectCell' && unref(column).groupFlag !== true && unref(column).showColType === 'tag';
});

const cellComponentProps = computed(() => ({
  cellContent: cellContentValue.value,
  column: unref(column),
  closeEditorFlag: props.closeEditorFlag,
  gridKey: props.gridKey,
  index: props.index,
  options: unref(options),
  record: unref(record),
  preRecord: unref(preRecord),
  showColType: unref(column).showColType,
}));

const handleCellDoubleClick = (record, column) => {
  emits('handleCellDoubleClick',{record, column});
}
</script>

<style type="text/css" lang="less">
.xm-common-table{
  .editor-cell{
    display: flex;
    align-items: center;
    min-width: 0;
  }
}

.cell-text-suf-wrap {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;

  .cell-text-part {
    flex: 0 1 auto;
    min-width: 0;
    width: auto !important;
    overflow: hidden;

    &.ant-tag {
      max-width: 100%;
    }

    &.w100b {
      width: auto !important;
    }

    .w100b {
      width: auto !important;
    }

    .text-dian-dian {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .cell-suf-label {
    flex-shrink: 0;
    margin-left: 4px;
  }
}

.ant-tag.cell-affix-label-hollow {
  background: transparent !important;
}

.cell-content.linkText{
  color:var(--primary-color,#0a6eff);
  cursor:pointer;
}
.userDefDiv{
  &.linkText{
    color:var(--primary-color,#0a6eff);
    cursor:pointer;
  }
}
</style>
